import EsusView from 'components/esus/EsusView'

export default function AtendimentoIndividualView() {
  return <EsusView url='/pec/user/relatorios/producao/analiticoAtendimentoIndividual' />
}
